import { usePersistedSessionState } from "@edreamsodigeo/frontend-core";

const useHasDynpackCustomerSelectedPrimePrice = (): boolean => {
  const [isDpNonPrimePriceSelected] = usePersistedSessionState(
    "isDpNonPrimePriceSelected",
  );

  return !isDpNonPrimePriceSelected;
};

export default useHasDynpackCustomerSelectedPrimePrice;
